var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('Loader'):_c('div',[_c('BaseResult',{attrs:{"questions":_vm.questions,"can_delete":_vm.can_delete},on:{"deleteQuestion":_vm.deleteQuestion}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }